import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { CookiesManagerSiteConfig } from '../types'

const cookiesManagerSiteConfig: SiteConfigFn<CookiesManagerSiteConfig> = ({ api, funcLib }) => {
	const isMultilingualActive = api.features.isActive('multilingual')

	const urlObject = funcLib.parseUrl(api.publicModel.getExternalBaseUrl())

	return {
		shouldLoadSiteFeature: isMultilingualActive,
		shouldLoadSiteConfig: isMultilingualActive,
		siteConfig: {
			cookieSitePath: urlObject.pathname,
			cookieSiteDomain: urlObject.hostname,
		},
	}
}

const name = 'cookiesManager'

export const config = { site: cookiesManagerSiteConfig, name }
